//Shop Categories hover
jQuery(document).ready(function($) {
	$.fn.hasScrollBar = function() {
		return this.get(0).scrollHeight > this.height();
	};

	let navItem = $('.wc-shop__sec-nav li.nav-item');

	navItem.on('mouseenter', function(){
		$(this).addClass('hover');
		$(this).parent().addClass('hovering');

		if ( $(this).find('.first-level ul').length > 0 ) {
			if ( $(this).find('.first-level ul').hasScrollBar() && $(this).find('.first-level ul li.active').length > 0 ) {
				let ulHeight = $(this).find('.first-level ul').height();
				let offset = $(this).find('.first-level ul li.active').offset().top - $(this).find('.first-level ul').offset().top;

				if ( offset >= ulHeight - 100 ) {
					$(this).find('.first-level ul').animate({
						scrollTop: offset
					});
				}
			}
		}
	});
	navItem.on('mouseleave', function(){
		$(this).removeClass('hover');
		$(this).parent().removeClass('hovering');
	});
	if($('.wc-shop__sec-nav li.nav-item .first-level li').hasClass('hover')){


		var lterm = $('.wc-shop__sec-nav li.nav-item .first-level li.hover').attr('linked-term');

		$('.wc-shop__sec-nav li.nav-item .second-level #'+ lterm).show();
	}
	$('.wc-shop__sec-nav li.nav-item').on('mouseenter', function(){

		if($(this).find('.first-level li.active').length == 0 ){
			let term = '';
			if($('body').hasClass('tax-product_cat')){
				term = $('body').attr('class').match(/term-\S+/)[0].replace('term-', '');
				if( $(this).find('li[linked-term="'+ term + '"]').length > 0){
					$('.wc-shop__sec-nav li.nav-item .first-level li[linked-term="'+ term + '"]').addClass('hover');
				}else{
					$(this).find('.first-level li:first-of-type').addClass('active');
					term = $(this).find('.first-level li:first-of-type').attr('linked-term');
				}
			} else{
				$(this).find('.first-level li:first-of-type').addClass('active');
				term = $(this).find('.first-level li:first-of-type').attr('linked-term');
			}

			$('.wc-shop__sec-nav li.nav-item .second-level #'+ term).show();
		} else {
			let activeTerm = $(this).find('.first-level li.active').attr('linked-term');
			$(this).find('.second-level #' + activeTerm).show();
		}
	});


	$('.wc-shop__sec-nav li.nav-item .first-level li').on('mouseenter', function() {
		$(this).parent().addClass('hovering');
		$('.wc-shop__sec-nav li.nav-item .second-level div').hide();
		let divid = $('.wc-shop__sec-nav li.nav-item .first-level li.hover').attr('linked-term');
		$('.wc-shop__sec-nav li.nav-item .first-level li.hover').removeClass('hover');
		$('.wc-shop__sec-nav li.nav-item .second-level #'+ divid).hide();
		$('.wc-shop__sec-nav li.nav-item .first-level li[linked-term="'+ $(this).attr('linked-term') + '"]').addClass('hover');
		$('.wc-shop__sec-nav li.nav-item .first-level li.hover').prev().css('border-bottom', 'none');
		if(!$('.wc-shop__sec-nav li.nav-item .first-level li[linked-term="'+ $(this).attr('linked-term') + '"]').hasClass('active')){
			$('.wc-shop__sec-nav li.nav-item .first-level li.active').css('border-radius', '0px');
		}
		$('.wc-shop__sec-nav li.nav-item .second-level #'+ $(this).attr('linked-term')).show();
	});

	$('.wc-shop__sec-nav li.nav-item .first-level li').on('mouseleave', function() {
		let lterm = $(this).attr('linked-term');
		let parent = $(this).parent();
		let parentNav = $(this).parents('li.nav-item');
		$('.wc-shop__sec-nav li.nav-item .first-level li.active').css('border-radius', '6px');

		$('.wc-shop__sec-nav li.nav-item .first-level li.hover').prev().css('border-bottom', '1px solid rgba(0, 0, 0, 0.1)');

		if ($('.wc-shop__sec-nav li.nav-item .second-level:hover').length === 0) {
			$('.wc-shop__sec-nav li.nav-item .second-level #' + lterm).hide();
			$('.wc-shop__sec-nav li.nav-item .first-level li[linked-term="' + lterm + '"]').removeClass('hover');
			parent.removeClass('hovering');

			let activeTerm = parentNav.find('.first-level li.active').attr('linked-term');
			parentNav.find('.second-level #' + activeTerm).show();
		} else {
			$('.wc-shop__sec-nav li.nav-item .second-level').on('mouseleave', function () {
				$('.wc-shop__sec-nav li.nav-item .second-level #' + lterm).hide();
				$('.wc-shop__sec-nav li.nav-item .first-level li[linked-term="' + lterm + '"]').removeClass('hover');

				if ( $('.wc-shop__sec-nav li.nav-item .first-level ul:hover').length === 0 ) {
					parent.removeClass('hovering');
				}
			});
		}
	});
});